import React from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {reduxForm, Field} from 'redux-form'
import {editCampainField} from 'redux/modules/sites/actions'
import FormInput from 'components/FormInput'
import {getCurrentSite} from 'redux/modules/currentUser/selectors'

export class CampaignFieldView extends React.Component {
  static propTypes = {
    currentSite: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    isFetching: PropTypes.bool
  }

  render() {
    return (
      <div className='campaign-view'>
        <div className='campaign-view_intro'>
          This is the configuration section for the campaign.
          <i className='campaign-view_intro_desc'>
            Campaign will be filled with the value of the selected parameter.
          </i>
        </div>
        {this.renderForm()}
      </div>
    )
  }

  renderForm() {
    const {handleSubmit, invalid, currentSite, isFetching} = this.props
    const {campaignField} = currentSite
    console.log('campaignField', campaignField)
    return (
      <form
        onSubmit={handleSubmit}
      >
        <Field name='campaignField' label='Campaign Parameter' component={FormInput} />
        <button type='submit' disabled={invalid || isFetching}>
          Save
        </button>
      </form>
    )
  }
}

const Form = reduxForm({
  form: 'campaignFielForm',
  validate: ({campaignField: value}, props) => {
    const errors = {
      campaignField: value === props.currentSite.campaignField
    }

    return errors
  },
  onSubmit: ({campaignField}, dispatch, props) => {
    const siteId = props.currentSite.id
    dispatch(
      editCampainField({
        id: siteId,
        campaignField: campaignField || null
      })
    )
  }
})(CampaignFieldView)

const mapStateToProps = state => {
  const currentSite = getCurrentSite(state)
  return {
    currentSite,
    isFetching: state.sites.isFetching,
    initialValues: {
      campaignField: currentSite.campaignField
    }
  }
}

export default connect(mapStateToProps)(Form)



// WEBPACK FOOTER //
// ./client/views/SettingsCustomMappingView/CampaignFieldView.js